(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components'], factory) : factory(global.hedron = {}, global.React, global.styled);
})(this, function (exports, React, styled) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  var styled__default = 'default' in styled ? styled['default'] : styled;

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */


  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  var printWarning = function printWarning() {};

  {
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};

    printWarning = function printWarning(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */

  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    {
      for (var typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
          var error; // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.

          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
              err.name = 'Invariant Violation';
              throw err;
            }

            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }

          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }

          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  var checkPropTypes_1 = checkPropTypes;

  var printWarning$1 = function printWarning$1() {};

  {
    printWarning$1 = function printWarning$1(text) {
      var message = 'Warning: ' + text;

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */

    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }
    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */


    var ANONYMOUS = '<<anonymous>>'; // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */

    /*eslint-disable no-self-compare*/

    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */


    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    } // Make `instanceof Error` still work for returned errors.


    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }

      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;

            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }

        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }

            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }

          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }

        var propValue = props[propName];

        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }

        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        printWarning$1('Invalid argument supplied to oneOf, expected an instance of array.');
        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];

        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }

        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }

        for (var key in propValue) {
          if (propValue.hasOwnProperty(key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

            if (error instanceof Error) {
              return error;
            }
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.');
        return emptyFunctionThatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (typeof checker !== 'function') {
          printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }

      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }

        for (var key in shapeTypes) {
          var checker = shapeTypes[key];

          if (!checker) {
            continue;
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);

        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        } // We need to check all keys in case some are required but missing from
        // props.


        var allKeys = objectAssign({}, props[propName], shapeTypes);

        for (var key in allKeys) {
          var checker = shapeTypes[key];

          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }

          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error) {
            return error;
          }
        }

        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;

        case 'boolean':
          return !propValue;

        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }

          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);

          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;

            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;

                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;

        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      } // Fallback for non-spec compliant Symbols which are polyfilled.


      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    } // Equivalent of `typeof` but with special handling for array and regexp.


    function getPropType(propValue) {
      var propType = typeof propValue;

      if (Array.isArray(propValue)) {
        return 'array';
      }

      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }

      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }

      return propType;
    } // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.


    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }

      var propType = getPropType(propValue);

      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }

      return propType;
    } // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"


    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);

      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;

        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;

        default:
          return type;
      }
    } // Returns class name of the object, if any.


    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }

      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

      var isValidElement = function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }; // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
    }
  });

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  };

  var _templateObject = taggedTemplateLiteral(["\n          ", " {\n            ", ";\n            ", ";\n          }\n        "], ["\n          ", " {\n            ", ";\n            ", ";\n          }\n        "]);

  var drawDebug = function drawDebug() {
    return ["background: rgba(0, 255, 255, 0.1);", "border: 1px dashed rgba(255, 0, 255, 1);"];
  };
  /**
   * Returns % width based on alias. Returns
   * string with if alias is not passed
   * @param {string} alias
   */


  var processAlias = function processAlias(alias) {
    switch (alias) {
      case "half":
        return "50%";
        break;

      case "quarter":
        return "25%";
        break;

      case "third":
        return "33.3333333%";
        break;

      case "twoThirds":
        return "66.666666%";
        break;

      case "threeQuarters":
        return "75%";
        break;

      default:
        return alias;
    }
  };

  var cssProperties = {
    padding: function padding(data) {
      return "padding: " + data + ";";
    },
    paddingLeft: function paddingLeft(data) {
      return "padding-left: " + data + ";";
    },
    paddingRight: function paddingRight(data) {
      return "padding-right: " + data + ";";
    },
    paddingTop: function paddingTop(data) {
      return "padding-top: " + data + ";";
    },
    paddingBottom: function paddingBottom(data) {
      return "padding-bottom: " + data + ";";
    },
    margin: function margin(data) {
      return "margin: " + data + ";";
    },
    marginLeft: function marginLeft(data) {
      return "margin-left: " + data + ";";
    },
    marginRight: function marginRight(data) {
      return "margin-right: " + data + ";";
    },
    marginTop: function marginTop(data) {
      return "margin-top: " + data + ";";
    },
    marginBottom: function marginBottom(data) {
      return "margin-bottom: " + data + ";";
    },
    width: function width(data) {
      return "width: " + processAlias(data) + ";";
    },
    height: function height(data) {
      return "height: " + processAlias(data) + ";";
    },
    visibility: function visibility(data) {
      return "visibility: " + data + ";";
    },
    display: function display(data) {
      return "display: " + data + ";";
    },
    opacity: function opacity(data) {
      return "opacity: " + data + ";";
    },
    color: function color(data) {
      return "color: " + data + ";";
    },
    background: function background(data) {
      return "background: " + data + ";";
    },
    border: function border(data) {
      return "border: " + data + ";";
    },
    fontSize: function fontSize(data) {
      return "font-size: " + data + ";";
    },
    fontWeight: function fontWeight(data) {
      return "font-weight: " + data + ";";
    },
    fontStyle: function fontStyle(data) {
      return "font-style: " + data + ";";
    },
    fontFamily: function fontFamily(data) {
      return "font-family: " + data + ";";
    },
    lineHeight: function lineHeight(data) {
      return "line-height: " + data + ";";
    },
    textTransform: function textTransform(data) {
      return "text-transform: " + data + ";";
    },
    hidden: function hidden() {
      return "display: none;";
    }
  };
  /**
   * Returns an array of valid css declarations generated
   * from the react props supplied.
   *
   * @param {array} props list of react props
   */

  var generateStyles = function generateStyles(props) {
    var cssProps = [];
    Object.keys(props).map(function (prop) {
      if (cssProperties[prop]) cssProps.push(cssProperties[prop](props[prop]));
    });
    return cssProps;
  };
  /**
   * This will parse a breakpoint string (i.e. -500) and return
   * the operation needed to generate a media query
   * @param {string} breakpoint
   */


  var parseBreakpoint = function parseBreakpoint(breakpoint) {
    switch (breakpoint.charAt(0)) {
      // less than
      case "-":
        return {
          lt: breakpoint.substring(1)
        };
        break;
      // more than

      case "+":
        return {
          gt: breakpoint.substring(1)
        };
        break;
      // range

      default:
        var range = breakpoint.split("-");

        if (range.length !== 2) {
          console.error("Invalid breakpoint range. The proper syntax for a range is: min-max");
        }

        return {
          range: range
        };
    }
  };
  /**
   * Generates a media query from a breakpoint operation
   *
   * @param {Object} operation
   */


  var media = function media(operation) {
    if (operation.lt) {
      return "@media (max-width: " + operation.lt + "px)";
    } else if (operation.gt) {
      return "@media (min-width: " + operation.gt + "px)";
    } else if (operation.range) {
      return "@media (min-width: " + operation.range[0] + "px) and (max-width: " + operation.range[1] + "px)";
    }
  };
  /**
   * Generates valid CSS media queries from a component's props
   *
   * @param {Object} props
   */


  var breakpoints = function breakpoints(props) {
    if (!props.breakpoints) return null;
    return Object.keys(props.breakpoints).map(function (id) {
      return props[id] && [styled.css(_templateObject, media(parseBreakpoint(props.breakpoints[id])), generateStyles(props[id]), flex(props[id]))];
    });
  };

  var translations = {
    direction: {
      horizontal: "row",
      vertical: "column"
    },
    wrap: {
      true: "wrap",
      1: "wrap",
      false: "nowrap",
      0: "nowrap"
    },
    align: {
      top: "flex-start",
      left: "flex-start",
      bottom: "flex-end",
      right: "flex-end",
      center: "center",
      middle: "center"
    }
  };

  var flex = function flex(_ref) {
    var flex = _ref.flex,
        fill = _ref.fill,
        direction = _ref.direction,
        wrap = _ref.wrap,
        valign = _ref.valign,
        halign = _ref.halign,
        shiftLeft = _ref.shiftLeft,
        shiftRight = _ref.shiftRight,
        shiftUp = _ref.shiftUp,
        shiftDown = _ref.shiftDown;
    var props = [];
    if (flex) props.push("flex: " + flex + ";");
    if (fill) props.push("flex: 1 1 auto;");
    if (direction) props.push("flex-direction: " + translations.direction[direction] + ";");
    if (wrap) props.push("flex-wrap: " + translations.wrap[wrap] + ";");

    if (halign) {
      if (direction === "horizontal") props.push("justify-content: " + translations.align[halign] + ";");else props.push("align-items: " + translations.align[halign] + ";");
    }

    if (valign) {
      if (direction === "horizontal") props.push("align-items: " + translations.align[valign] + ";");else props.push("justify-content: " + translations.align[valign] + ";");
    }

    if (shiftLeft) props.push("margin-right: auto;");
    if (shiftRight) props.push("margin-left: auto;");
    if (shiftUp) props.push("margin-bottom: auto;");
    if (shiftDown) props.push("margin-top: auto;");
    return props;
  }; // eslint-disable-next-line max-len


  var stripBoolean = function stripBoolean(Element) {
    return function (_ref2) {
      var debug = _ref2.debug,
          fluid = _ref2.fluid,
          fill = _ref2.fill,
          wrap = _ref2.wrap,
          props = objectWithoutProperties(_ref2, ["debug", "fluid", "fill", "wrap"]);
      return React__default.createElement(Element, props);
    };
  };

  var defaultBreakpoints = {
    sm: [0, 500],
    md: [501, 768],
    lg: [769, 1100]
  };

  var Provider = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
      classCallCheck(this, Provider);
      return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
      key: "getChildContext",
      value: function getChildContext() {
        var _props = this.props,
            _props$breakpoints = _props.breakpoints,
            propsBreakpoints = _props$breakpoints === undefined ? {} : _props$breakpoints,
            propsPadding = _props.padding,
            propsDebug = _props.debug;
        var _context = this.context,
            _context$breakpoints = _context.breakpoints,
            contextBreakpoints = _context$breakpoints === undefined ? {} : _context$breakpoints,
            contextPadding = _context.padding,
            contextDebug = _context.debug;
        return {
          breakpoints: _extends({}, defaultBreakpoints, contextBreakpoints, propsBreakpoints),
          padding: propsPadding || contextPadding || "5px",
          debug: propsDebug || contextDebug || false
        };
      }
    }, {
      key: "render",
      value: function render() {
        return React.Children.only(this.props.children);
      }
    }]);
    return Provider;
  }(React.Component);

  Provider.propTypes = {
    children: propTypes.node,
    breakpoints: propTypes.object,
    padding: propTypes.string
  };
  Provider.contextTypes = {
    breakpoints: propTypes.object,
    padding: propTypes.string,
    debug: propTypes.bool
  };
  Provider.childContextTypes = {
    breakpoints: propTypes.object,
    padding: propTypes.string,
    debug: propTypes.bool
  };

  var withBreakpoints = function withBreakpoints(WrappedComponent) {
    var _class, _temp;

    return (// eslint-disable-next-line react/no-multi-comp
      _temp = _class = function (_Component2) {
        inherits(_class, _Component2);

        function _class() {
          classCallCheck(this, _class);
          return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        createClass(_class, [{
          key: "render",
          // inherit propTypes from source component
          // eslint-disable-line  react/prefer-stateless-function
          value: function render() {
            // console.log(WrappedComponent.propTypes);
            var _context2 = this.context,
                breakpoints = _context2.breakpoints,
                padding = _context2.padding,
                debug = _context2.debug;
            var props = {
              breakpoints: breakpoints,
              debug: debug
            }; // Hacky method of ignoring some components when applying padding

            if (WrappedComponent.render ? !([Bounds.render.prototype].indexOf(WrappedComponent.render.prototype) !== -1) : !([Bounds.prototype].indexOf(WrappedComponent.prototype) !== -1)) {
              props.padding = padding;
            }

            return React__default.createElement(WrappedComponent, _extends({}, this.props, props));
          } // inherit defaultProps from source component
          // inherit displayName from source component

        }]);
        return _class;
      }(React.Component), _class.contextTypes = {
        breakpoints: propTypes.object,
        padding: propTypes.string,
        debug: propTypes.bool
      }, _class.displayName = WrappedComponent.displayName || WrappedComponent.name, _class.propTypes = WrappedComponent.propTypes, _class.defaultProps = WrappedComponent.defaultProps, _temp
    );
  };

  var Base = function Base(element) {
    return styled__default(stripBoolean(element))(generateStyles);
  };

  Base.propTypes = {
    // Positioning
    padding: propTypes.string,
    margin: propTypes.string,
    width: propTypes.string,
    height: propTypes.string,
    // Display
    visibility: propTypes.string,
    display: propTypes.string,
    opacity: propTypes.number,
    // Coloring
    color: propTypes.string,
    background: propTypes.string,
    border: propTypes.string,
    // Text
    fontSize: propTypes.string,
    fontWeight: propTypes.oneOf([propTypes.string, propTypes.number]),
    fontStyle: propTypes.string,
    fontFamily: propTypes.string,
    lineHeight: propTypes.number,
    textTransform: propTypes.string,
    // Convenience Properties
    hidden: propTypes.bool
  };

  var _templateObject$1 = taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n"]);
  /**
   * Bounds functions as a container to wrap `Box` components.
   * The only components that should be a direct children of `Bounds`
   * are `Box` or `Bounds`.
   */


  var Bounds = styled__default(Base("div"))(_templateObject$1, function (props) {
    return props.debug && drawDebug();
  }, function (props) {
    return flex(props);
  }, function (props) {
    return breakpoints(props);
  });
  Bounds.propTypes = _extends({
    /**
     * Enable if you want the geometry of the grid exposed
     */
    debug: propTypes.bool,

    /**
     * Interface for setting the `flex` css property
     */
    flex: propTypes.string,

    /**
     * The primary axis the children should be in line with
     */
    direction: propTypes.oneOf(["horizontal", "vertical"]),

    /**
     * Whether children should wrap when there's no more room
     * on the primary axis.
     */
    wrap: propTypes.bool,

    /**
     * Alignment of children along the vertical axis
     */
    valign: propTypes.oneOf(["top", "center", "bottom", null]),

    /**
     * Alignment of children along the horizontal axis
     */
    halign: propTypes.oneOf(["left", "center", "right", null])
  }, Base.propTypes);
  Bounds.defaultProps = _extends({
    debug: false,
    direction: "horizontal",
    wrap: false
  }, Base.defaultProps);
  var Bounds$1 = withBreakpoints(Bounds);

  var _templateObject$2 = taggedTemplateLiteral(["\n  ", " box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", " box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"]);

  var Box = styled__default(Base("div"))(_templateObject$2, function (props) {
    return props.fluid && "padding: 0;";
  }, function (props) {
    return props.debug && drawDebug();
  }, function (props) {
    return flex(props);
  }, function (props) {
    return breakpoints(props);
  });
  Box.propTypes = _extends({
    // Debug Properties
    debug: propTypes.bool,
    // Flex-specific Properties
    flex: propTypes.bool,
    fill: propTypes.bool,
    fluid: propTypes.bool,
    shiftRight: propTypes.bool,
    shiftLeft: propTypes.bool,
    shiftUp: propTypes.bool,
    shiftDown: propTypes.bool
  }, Base.propTypes);
  Box.defaultProps = _extends({
    debug: false,
    fill: false
  }, Base.defaultProps);
  var Box$1 = withBreakpoints(Box);
  var index = {
    Provider: Provider,
    Bounds: Bounds$1,
    Box: Box$1
  };
  exports.default = index;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});